import styled, { keyframes } from 'styled-components';

import { ReactComponent as CloseIcon } from 'static/icons/close.svg';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const Container = styled.div`
  background-color: #fff;
  border: 1px solid ${(props) => props.theme.color.porcelain};
  border-radius: 12px;
  width: auto;
  height: fit-content;
  padding: 8px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  z-index: 3;
  position: sticky;
  animation: ${slideIn} 0.3s ease-out;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.98);

  &[data-size='small'] {
    width: 280px;
    padding: 6px 12px;
    min-height: 32px;
  }

  &[data-size='medium'] {
    width: 360px;
    padding: 8px 16px;
    min-height: 40px;
  }

  &[data-size='large'] {
    width: 440px;
    padding: 12px 20px;
    min-height: 48px;
  }

  &[data-dismissing='true'] {
    animation: ${fadeOut} 0.3s ease-out forwards;
  }

  a {
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
    transform: translateY(-1px);
  }
`;

export const Message = styled.div`
  color: ${(props) => props.theme.color.pickledBluewood};
  margin-left: 12px;
  display: flex;
  margin-right: 20%;
  line-height: 1.5;
  flex: 1;
  flex-direction: column;
  overflow: hidden;

  ${Container}[data-size="small"] & {
    font-size: 12px;
  }

  ${Container}[data-size="medium"] & {
    font-size: 13px;
  }

  ${Container}[data-size="large"] & {
    font-size: 14px;
  }

  span {
    font-weight: 400;
    display: block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const Bage = styled.div`
  width: 4px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${({ appearance, theme }) => {
    switch (appearance) {
      case 'error':
        return theme.color.bittersweet;
      case 'success':
        return theme.color.brightTurquoise;
      case 'warning':
        return theme.color.bittersweet;
      case 'info':
        return theme.color.bittersweet;
      default:
        return theme.color.brightTurquoise;
    }
  }};
  border-radius: 4px 0 0 4px;
  box-shadow: 0 0 8px
    ${({ appearance, theme }) => {
      switch (appearance) {
        case 'error':
          return `${theme.color.bittersweet}40`;
        case 'success':
          return `${theme.color.brightTurquoise}40`;
        case 'warning':
          return '#FFB02040';
        case 'info':
          return '#3B82F640';
        default:
          return `${theme.color.brightTurquoise}40`;
      }
    }};
`;

export const StyledClose = styled(CloseIcon)`
  user-select: none;
  inset: 0px;
  margin: auto;
  transition: transform 0.2s ease;

  ${Container}[data-size="small"] & {
    width: 14px;
    height: 14px;
  }

  ${Container}[data-size="medium"] & {
    width: 16px;
    height: 16px;
  }

  ${Container}[data-size="large"] & {
    width: 18px;
    height: 18px;
  }

  path {
    fill: ${({ theme }) => theme.color.pickledBluewood};
    transition: fill 0.2s ease;
  }
`;

export const StyledImg = styled.img`
  border-radius: 6px;
  object-fit: cover;
  margin-left: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  ${Container}[data-size="small"] & {
    width: 24px;
    height: 24px;
  }

  ${Container}[data-size="medium"] & {
    width: 32px;
    height: 32px;
  }

  ${Container}[data-size="large"] & {
    width: 40px;
    height: 40px;
  }
`;

export const CloseBtnWrapper = styled.div`
  padding: 6px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 8px;
  position: absolute;
  z-index: 2;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.color.porcelain};

    ${StyledClose} {
      transform: scale(1.1);

      path {
        fill: ${({ theme }) => theme.color.pickledBluewood};
      }
    }
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.color.brightTurquoise};
  }
`;

export const Title = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
  color: ${({ theme }) => theme.color.pickledBluewood};
  letter-spacing: -0.01em;

  ${Container}[data-size="small"] & {
    font-size: 13px;
  }

  ${Container}[data-size="medium"] & {
    font-size: 14px;
  }

  ${Container}[data-size="large"] & {
    font-size: 16px;
  }
`;

export const Subscription = styled.div`
  color: ${({ theme }) => theme.color.pickledBluewood};
  opacity: 0.85;
  margin-top: 4px;
  letter-spacing: -0.01em;

  ${Container}[data-size="small"] & {
    font-size: 11px;
  }

  ${Container}[data-size="medium"] & {
    font-size: 12px;
  }

  ${Container}[data-size="large"] & {
    font-size: 13px;
  }
`;
